import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {useTranslation} from '@/translations/i18n'
import {ErrorBox} from '../error-box/ErrorBox'
import {AlertCircleIcon, ArrowLeftIcon} from '@/components/ui/icon/Icon'

export const NoPermissionBox = () => {
    const {t} = useTranslation()

    return (
        <ErrorBox
            title={t('errors:no_permission_page')}
            icon={<AlertCircleIcon />}
            cta={
                <ButtonLink size="xl" variant="secondary" to="/">
                    <ArrowLeftIcon />
                    {t('commons:back_to_homepage')}
                </ButtonLink>
            }
        />
    )
}
